import { downloadExcel } from '@store/excel.reducer'
import API from './apiCreate'
import { getHeaders } from './getHeaders'
import { getParams } from './getParams'
import axios from 'axios'
export { API }
export * from './queries/index'

const cancelToken = {
  groupSeminarian: null,
  groupOverview: null,
  getWorks: null,
  getUsers: null,
}

export const usersAPI = {
  create: (conf) => API.post('user/create', conf.data, getHeaders()),
  getUsers: ({ params, ...conf }) =>
    API.get(`user/${getParams(conf)}`, getHeaders()),
  getUsersCancel: ({ params, ...conf }) => {
    if (cancelToken.getUsers)
      cancelToken.getUsers.cancel(
        'Previous request canceled due to new request.',
      )

    cancelToken.getUsers = axios.CancelToken.source()

    return API.get(`user/${getParams(conf)}`, {
      headers: getHeaders().headers,
      cancelToken: cancelToken.getUsers.token, // Передаем токен отмены здесь
    })
  },
  getUser: (conf) =>
    API.get(`user/view/${conf.id}${getParams(conf)}`, getHeaders()),
  upd: (conf) => API.put(`user/update/${conf.id}`, conf.data, getHeaders()),
  disable: (conf) =>
    API.put(`user/disable/${conf.id}`, conf.data, getHeaders()),
  restore: (conf) =>
    API.put(`user/restore/${conf.id}`, conf.data, getHeaders()),
  setStatus: (conf) =>
    API.put(`user/set-status/${conf.id}`, conf.data, getHeaders()),
  updateBalance: (conf) =>
    API.put(`user/update-balance/${conf.id}`, conf.data, getHeaders()),
  addContract: (conf) =>
    API.post('user/upload-contract', conf.data, getHeaders(['FormData'])),
  removeContract: (conf) =>
    API.delete(`user/delete-contract/${conf.id}`, conf.data, getHeaders()),
  updAvatar: (conf) =>
    API.put(
      `user/update-avatar/${conf.id}`,
      conf.data,
      getHeaders(['FormData']),
    ),
  register: (body) => API({ url: `user/signup`, ...body, method: 'POST' }),
  signupVk: (body) => API.post(`auth/signup-vk`, body),
  changePassword: (conf) =>
    API.post(`user/change-password/${conf.id}`, conf.data, getHeaders()),
  restorePassword: (body) => API.post(`auth/restore-password`, body),
  resetPassword: (conf) =>
    API.post(`user/reset-password/${conf.id}`, conf.data, getHeaders()),
  getStudents: ({ params }) =>
    API.get(`user/get-students-by-direction`, params),

  sendDocumentForVerification: (body) =>
    API.post(`user/document-verification`, body, getHeaders(['FormData'])),

  getChildrenRating: (body) => API({ url: `user/rating`, ...body }),

  getSeminarian: (conf) =>
    API.get(
      `user/seminarians-by-direction?directionId=${conf.direction_id
      }${getParams(conf, false)}`,
    ),
  addDirection: ({ data, params }) =>
    API({ url: `user/add-direction`, data, params, method: 'post' }),
  changeDirection: ({ id, data }) =>
    API.post(`user/change-direction?id=${id}`, data),
  directionBySeminarian: ({ id, params }) =>
    API({
      url: `user/directions-by-seminarian?seminarianId=${id}`,
      params,
      method: 'GET',
    }),
  removeDirection: ({ id }) =>
    API({ url: `user/delete-direction?id=${id}`, method: 'DELETE' }),
  prevDirectionOrder: (params) =>
    API({
      url: `user/get-prev-direction-order`,
      params,
      method: 'GET',
    }),

  studentsRating: (body) => API({ url: `user/students-rating`, ...body }),
  seminarianByDirection: ({ id }) =>
    API({
      url: `user/get-user-by-direction/?directionId=${id}&expand=seminarian`,
      method: 'GET',
    }),
  switchRole: (role) => API.post('user/switch-role', { role }),
  updateRoles: ({ id, data }) =>
    API.put(`user/update-roles/${id}`, data, getHeaders()),
  authorization: (id) => API.get(`user/authorization/${id}`),

  getUserFiles: (params = '') => API.get(`user-files/${params}`, getHeaders()),
  uploadPlatformMedia: (body, config) =>
    API.post(`user-files/save-file`, body, {
      ...config,
      headers: getHeaders(['FormData']),
    }),
  updatePlatformMedia: (body, config) =>
    API.post(`user-files/update-file`, body, {
      ...config,
      headers: getHeaders(['FormData']),
    }),
  deletePlatformMedia: (body) =>
    API.post(`user-files/delete-file`, body, getHeaders(['FormData'])),
  getColleaguesForGroup: ({name}) => API.get(`user/colleagues-for-group?name=${name}`),
  checkEmail: (email, courseId, classId, isParent) => {
    const params = new URLSearchParams();
    if (email) params.append('email', email);
    if (courseId) params.append('course_id', courseId);
    if (classId) params.append('class_id', classId);
    if (isParent) params.append('is_parent', isParent);
    return API.get(`user/check-email?${params.toString()}`);
  },

  checkPhone: (phone, courseId, classId, isParent) => {
    const params = new URLSearchParams();
    if (phone) params.append('phone', phone);
    if (courseId) params.append('course_id', courseId);
    if (classId) params.append('class_id', classId);
    if (isParent) params.append('is_parent', isParent);
    return API.get(`user/check-email?${params.toString()}`);
  },
  createParent: (data) => API.post('user/create-parent', data, getHeaders()),
  searchUsersForSelect: (params) => API.get(`user/search-for-select/${getParams(params)}`, getHeaders()),
};

export const profileAPI = {
  login: ({ email, password }) =>
    API.post(
      'auth/login/?expand=roles',
      { password, email },
      { withCredentials: true },
    ),
  // отправить в Redux
  // 2-ой енд поинт
  appLogin: ({ app_id, uuid }) =>
    API.post(
      'auth/login/?expand=roles',
      { type: 'app', app_id, uuid },
      { withCredentials: true },
    ),
}

export const staticDataAPI = {
  getRole: () => API.get('user/roles', getHeaders()),
}

export const thematicsAPI = {
  getAll: (body) =>
    API({
      url: `direction-filter`,
      ...body,
      params: { ...body?.params, pageSize: false },
    }),
  // getAllSubFolders: (body) =>
  //   API({
  //     url: `direction-filter/get-subfolders`,
  //     ...body,
  //     params: { ...body?.params, pageSize: false },
  //   }),
  getAllSubFolders: (body) =>
    API.get(
      `direction-filter/get-subfolders`,
      { ...body?.params, pageSize: false }, getHeaders()
    ),
  getAllNotEmpty: (body) =>
    API({
      url: `direction-filter/folders-not-empty`,
      ...body,
      params: { ...body?.params, pageSize: false },
    }),
  getAllSubFoldersNotEmpty: (body) =>
    API.get(
      `direction-filter/subfolders-not-empty`,
      { ...body?.params, pageSize: false },
      getHeaders(),
    ),
  add: (conf) => API.post('direction-filter/create', conf.data, getHeaders()),
  addSubFolder: (conf) =>
    API.post('direction-filter/create-subfolder', conf.data, getHeaders()),
  upd: (conf) =>
    API.put(`direction-filter/update/${conf.id}`, conf.data, getHeaders()),
  updSubfolder: (conf) =>
    API.put(`direction-filter/update-subfolder/${conf.id}`, conf, getHeaders()),
  remove: (conf) =>
    API.delete(`direction-filter/delete/${conf.id}`, getHeaders()),
  removeSubfolder: (id) =>
    API.delete(`direction-filter/delete-subfolder/${id}`, getHeaders()),
  view: (conf) => API.get(`direction-filter/view/${conf.id}`, getHeaders()),
  sorting: (conf) => API.post(`direction-filter/change-sorting`, conf.data),
}

export const directionAPI = {
  overview: (conf, signal) => API.get(`direction/overview/${getParams(conf)}`, { signal: signal }, getHeaders()),
  getAll: (conf) => API.get(`direction/${getParams(conf)}`, {}, getHeaders()),
  getCatalog: (conf) =>
    API.get(`direction/catalog${getParams(conf)}`, {}, getHeaders()),
  get: (conf) =>
    API.get(`direction/view/${conf.id}${getParams(conf)}`, getHeaders()),
  getTariff: (conf) =>
    API.get(`direction-tariff/view/${conf.id}`, getHeaders()),
  getHWbyMyCourse: (group_id, children_id) =>
    API.get(
      `direction-plan/group?group_id=${group_id}&children_id=${children_id}&expand=group.direction,group.coursePlans,group.materialPlans,group.lessonPlans.lesson.lessonTasks.task,group.teacher,group.lessonPlans.lesson.lessonVideos,group.lessonPlans.lesson.lessonMaterials,children.homeWork,group.materialPlans.children.homeWork`,
      {},
      getHeaders(),
    ),
  add: (conf) => API.post('direction/create', conf.data, getHeaders()),
  upd: (conf) =>
    API.post(`direction/update/${conf.id}`, conf.data, getHeaders()),
  remove: (conf) => API.delete(`direction/delete/${conf.id}`, getHeaders()),
  sorting: (conf) => API.post(`direction/change-sorting`, conf.data),
  getTeacherByDiraction: (conf) =>
    API.get(
      `direction/${getParams(conf)}&expand=directionSeminarians.seminarian`,
      {},
      getHeaders(),
    ),
  getTypes: () => API.get('/direction-tariff/types'),
  addFavorite: (data) => API.post('/direction/add-favorite', data),
  toggleView: (data) => API.post('/direction/toggle-view', data),
  createCopy: (data) => API.post('/direction/create-copy', data),
}

export const betaDirectionAPI = {
  get: (conf) =>
    API.get(`direction/view/${conf.id}${getParams(conf)}`, getHeaders()),
  getTariff: (conf) =>
    API.get(`direction-tariff/view/${conf.id}`, getHeaders()),
  add: (conf) => API.post('direction/create', conf.data, getHeaders()),
  upd: (conf) =>
    API.post(`direction/update/${conf.id}`, conf.data, getHeaders()),
  getTypes: () => API.get('/direction-tariff/types'),
}

export const courseAPI = {
  getAll: (conf) =>
    API.get(`direction-course/${getParams(conf)}`, getHeaders()),
  add: (data) => API.post('direction-course/create', data, getHeaders()),
  upd: (conf) =>
    API.put(`direction-course/update/${conf.id}`, conf.data, getHeaders()),
  remove: (id) => API.delete(`direction-course/delete/${id}`, getHeaders()),
  view: (conf) => API.get(`direction-course/view/${conf.id}${getParams(conf)}`),
  sorting: (conf) => API.post(`direction-course/change-sorting`, conf.data),
  getSchedule: (groupId, courseId) =>
    API.get(
      `direction-course/get-schedule?groupId=${groupId}&courseId=${courseId}`,
    ),
  uploadCourse: (data) => API.post(`direction-course/upload`, data),
  getLearningDynamics: (studentId) =>
    API.get(`direction-course/learning-dynamics?id=${studentId}`, getHeaders()),
  resetCourseLearningDynamic: (data) =>
    API.get(
      `direction-course/learning-dynamics-course-reset?userId=${data?.userId}&courseId=${data?.courseId}`,
    ),
  resetTopicLearningDynamic: (data) =>
    API.get(
      `direction-course/learning-dynamics-topic-reset?userId=${data?.userId}&courseId=${data?.courseId}&topicId=${data?.topicId}`,
    ),
}

export const themeAPI = {
  getAll: (conf) => API.get(`task-topic/${getParams(conf)}`, getHeaders()),
  get: (id) => API.get(`task-topic/${id}`, getHeaders()),
  add: (conf) => API.post('task-topic/create', conf.data, getHeaders()),
  upd: (conf) =>
    API.put(`task-topic/update/${conf.id}`, conf.data, getHeaders()),
  remove: (id) => API.delete(`task-topic/delete/${id}`, getHeaders()),
}

export const subThemeAPI = {
  getAll: (conf) => API.get(`task-subtopic/${getParams(conf)}`, getHeaders()),
  get: (id) => API.get(`task-subtopic/${id}`, getHeaders()),
  add: (data) => API.post('task-subtopic/create', data, getHeaders()),
  upd: (conf) =>
    API.put(`task-subtopic/update/${conf.id}`, conf.data, getHeaders()),
  remove: (id) => API.delete(`task-subtopic/delete/${id}`, getHeaders()),
}

export const examNumberAPI = {
  getAll: (conf) =>
    API.get(`task-exam-number/${getParams(conf)}`, getHeaders()),
  get: (id) => API.get(`task-exam-number/${id}`, getHeaders()),
  add: (conf) => API.post('task-exam-number/create', conf.data, getHeaders()),
  upd: (conf) =>
    API.put(`task-exam-number/update/${conf.id}`, conf.data, getHeaders()),
  remove: (id) => API.delete(`task-exam-number/delete/${id}`, getHeaders()),
}

export const homeTaskApi = {
  getTypes: () => API.get('home-task/task-types', getHeaders()),
  getAll: (conf) => API.get(`home-task/${getParams(conf)}`, getHeaders()),
  get: (id) =>
    API.get(`home-task/view/${id}?expand=homeTaskFiles`, getHeaders()),
  add: (conf) =>
    API.post(
      `home-task/create/${getParams(conf)}`,
      conf.data,
      getHeaders(['FormData']),
    ),
  upd: (conf) =>
    API.put(
      `home-task/update/${conf.id}${getParams(conf)}`,
      conf.data,
      getHeaders(['FormData']),
    ),
  remove: (id) => API.delete(`home-task/delete/${id}`, getHeaders()),
  removeFile: (id) =>
    API.delete(`home-task/delete-file-task/${id}`, getHeaders()),
}

export const courseMaterialApi = {
  getAll: (conf) => API.get(`course-material/${getParams(conf)}`, getHeaders()),
  add: (data) => API.post('course-material/create', data, getHeaders()),
  upd: (conf) =>
    API.put(`course-material/update/${conf.id}`, conf.data, getHeaders()),
  view: (conf) =>
    API.get(`course-material/view/${conf.id}${getParams(conf)}`, getHeaders()),
  remove: (id) => API.delete(`course-material/delete/${id}`, getHeaders()),
  updProbe: (conf) =>
    API.put(`course-material/update-probe/${conf.id}`, conf.data, getHeaders()),
  updControl: (conf) =>
    API.put(
      `course-material/update-control/${conf.id}`,
      conf.data,
      getHeaders(),
    ),
  updColloquium: (conf) =>
    API.put(
      `course-material/update-colloquium/${conf.id}`,
      conf.data,
      getHeaders(['FormData']),
    ),
  updColloquiumGallery: (conf) =>
    API.put(
      `course-material/update-colloquium-gallery/${conf.id}`,
      conf.data,
      getHeaders(),
    ),
  removeColloquiumGallery: (id) =>
    API.delete(`course-material/delete-colloquium-gallery/${id}`, getHeaders()),

  sorting: (conf) => API.post(`course-material/change-sorting`, conf.data),
}

export const lessonThemeApi = {
  getAll: (conf) => API.get(`topic-lesson/${getParams(conf)}`, getHeaders()),
  add: (data) => API.post('topic-lesson/create', data, getHeaders()),
  upd: (conf, config = {}) =>
    API.put(`topic-lesson/update/${conf.id}`, conf.data, {
      ...config,
      headers: getHeaders().headers,
    }),
  view: (conf) =>
    API.get(`topic-lesson/view/${conf.id}${getParams(conf)}`, getHeaders()),
  remove: (id) => API.delete(`topic-lesson/delete/${id}`, getHeaders()),
  setRating: (body) =>
    API({ url: 'topic-lesson/set-video-rating', ...body, method: 'POST' }),
  getLessonData: (params) =>
    API.get(`topic-lesson/get-lesson-data`, { params }),
  getReactionsBlocks: (params) => API.get('/topic-lesson/reactions-blocks', { params }),
  setRatingBlock: (body) =>
    API({ url: 'topic-lesson/set-rating-block', ...body, method: 'POST' }),
}

export const childrenAPI = {
  add: (data) => API.post('user/create-children', data, getHeaders()),
}

export const additionalProbeApi = {
  getAll: (conf) =>
    API.get(`additional-probe${'/' + getParams(conf)}`, getHeaders()),
  add: (conf) =>
    API.post(
      `additional-probe/create/${getParams(conf)}`,
      conf.data,
      getHeaders(),
    ),
  upd: (conf) =>
    API.put(
      `additional-probe/update/${conf.id}${getParams(conf)}`,
      conf.data,
      getHeaders(),
    ),
  view: (conf) =>
    API.get(`additional-probe/view/${conf.id}${getParams(conf)}`, getHeaders()),
  remove: (conf) =>
    API.delete(`additional-probe/delete/${conf.id}`, getHeaders()),
}

//Groups
export const directionGroupApi = {
  get: (conf) => API.get(`direction-group${getParams(conf)}`, getHeaders()),
  getWithPagination: (conf) =>
    API.get(`direction-group/get-with-pagination${getParams(conf)}`),
  add: (conf) =>
    API.post(
      `direction-group/create/${getParams(conf)}`,
      conf.data,
      getHeaders(),
    ),
  addStudents: (conf) =>
    API.post(`direction-group/distribute`, conf.data, getHeaders()),
  updGroup: (conf) =>
    API.post(
      `direction-group/change-group${getParams(conf)}`,
      conf.data,
      getHeaders(),
    ),
  updSeminarian: (conf) =>
    API.post(
      `direction-group/change-teacher${getParams(conf)}`,
      conf.data,
      getHeaders(),
    ),
  updGroupName: (conf) =>
    API.post(
      `direction-group/change-name-group${getParams(conf)}`,
      conf.data,
      getHeaders(),
    ),

  updGroupTeacher: (conf) =>
    API.put(
      `direction-group/update/${conf.id}`,
      { teacher_id: conf.teacher_id },
      getHeaders(),
    ),

  removeGroup: (conf) =>
    API.post(`direction-group/delete-group/${conf.id.value}`, getHeaders()),

  getStudentsBygroup: (id) =>
    API.get(`/direction-group/get-students?group_id=${id}`),

  removeStudentsFromGroup: (params) =>
    API.post(`direction-group/remove-students`, params),
  moveStudentsToGroup: (data) => API.put(`direction-group/move-students`, data),
}

export const directionOrdersApi = {
  get: (conf) =>
    API.get(
      `direction-orders${getParams(conf)}${conf.notFree ? '&notFree=true' : ''
      }${conf.allRows ? '&allRows=true' : ''}`,
      getHeaders(),
    ),

  show: (id) => API.get(`direction-orders/show/${id}?expand=directionTariffs`),
  view: (conf) => API.get(`direction-orders/view?id=${conf.id}`),
  add: (conf) =>
    API.post(
      `direction-orders/create${getParams(conf)}`,
      conf.data,
      getHeaders(),
    ),
  remove: (conf, body = {}) =>
    API({
      url: `direction-orders/delete/${conf.id}`,
      ...body,
      method: 'DELETE',
    }),

  updComments: (conf) =>
    API.put(
      `direction-orders/update-comment?id=${conf.id}`,
      conf.data,
      getHeaders(),
    ),
  createOrder: (conf) =>
    API.post(
      `direction-orders/create-order${getParams(conf)}`,
      conf.data,
      getHeaders(['FormData']),
    ),
  getMyOrders: (conf) =>
    API({ url: `direction-orders/get-student-directions${getParams(conf)}`}),

  buy: (conf) =>
    API.post(`direction-orders/buy-direction${getParams(conf)}`, conf.data),
  enroll: (data) => API.post(`direction-orders/enroll-direction`, data),
  payment: (conf) => API.post(`direction-orders/payment`, conf.data),
  extend: (body) =>
    API({ url: `direction-orders/extend`, ...body, method: 'POST' }),
  extendByManager: (body) =>
    API({ url: `direction-orders/extend-by-manager`, ...body, method: 'POST' }),
  extendClass: (body) =>
    API({ url: `direction-orders/extend-class`, ...body, method: 'POST' }),
  extendClassByManager: (body) =>
    API({
      url: `direction-orders/extend-class-by-manager`,
      ...body,
      method: 'POST',
    }),
  activePromoCode: (conf) =>
    API.post(
      `direction-orders/active-promo-code?code=${conf.promo_code}`,
      conf.data,
    ),

  updPrivateInfo: ({ data, params }) =>
    API({
      url: `direction-orders/update-private-info`,
      data,
      params,
      method: 'PUT',
    }),

  index: (body) =>
    API({ url: `direction-orders/index`, ...body, method: 'GET' }),
  dataFilled: (body) =>
    API({ url: `direction-orders/data-filled`, ...body, method: 'PUT' }),
  sendToBot: (body) =>
    API({ url: `direction-orders/send-to-bot`, ...body, method: 'PUT' }),
  parentTouch: (body) =>
    API({ url: `direction-orders/parent-touch`, ...body, method: 'PUT' }),

  managerPayments: (body) =>
    API({ url: `direction-orders/manager-payments`, ...body, method: 'GET' }),
  orderDisable: (body) =>
    API({ url: `direction-orders/order-disable`, ...body, method: 'PUT' }),
  postpone: (body) =>
    API({ url: `direction-orders/postpone`, ...body, method: 'POST' }),
  postponeCancel: (body) =>
    API({ url: `direction-orders/postpone-cancel`, ...body, method: 'POST' }),

  getPrivateOwners: (teacher_id, direction_id) =>
    API.get(
      `direction-orders/private-students-by-seminarian?teacher_id=${teacher_id}&direction_id=${direction_id}`,
    ),

  addComment: (data) => API.post('direction-orders/add-comment', data),

  getHistoty: (conf) => API({ url: `direction-orders/get-payment-history${getParams(conf)}`, method: 'GET' }),
  getStudentsWithPagination: (params) =>
    API.get(
      `direction-orders/get-students-with-pagination/${getParams(params)}`,
    ),
}

export const childrenGroupApi = {
  getGroups: (conf) =>
    API.get(
      `direction-plan/group?group_id=${conf.id}&children_id=${conf.children}&noEmptyMaterialPlans=true&expand=group.direction,group.coursePlans.order.tariff,group.materialPlans,group.lessonPlans.lesson.lessonTasks.task,group.teacher,group.lessonPlans.lesson.lessonVideos,group.lessonPlans.lesson.lessonMaterials`,
    ),
  getIndividual: (conf) =>
    API.get(
      `direction-plan/private?directionId=${conf.id}&noEmptyMaterialPlans=true&expand=coursePlans,materialPlans,lessonPlans.lesson.lessonTasks.task,order.direction,order.teacher,lessonPlans.lesson.lessonVideos`,
    ),
}

export const beta = {
  saveOrderBlocks: (params) => API.post(`lesson-blocks/save-order`, params),
  deleteBlock: (id) => API.delete(`lesson-blocks/delete?id=${id}`),

  addBlockInLesson: (data) =>
    API.post('lesson-blocks/create', data, getHeaders()),
  saveBlockInLesson: (data) =>
    API.post('lesson-blocks/update', data, getHeaders()),
  updThemeData: (conf) =>
    API.put(`direction-plan-beta/update-theme`, conf.data, getHeaders()),

  remove: (id) => API.delete(`direction-plan-beta/delete-theme?id=${id}`),

  getMyCoursesBeta: (conf) =>
    API.get(`direction-orders-beta/my-courses${getParams(conf)}`, getHeaders()),

  getLessonsInTheTopic: (conf) =>
    API.get(
      `direction-plan-beta/get-theme-lessons${getParams(conf)}`,
      getHeaders(),
    ),
  getCourseBlocks: (conf) =>
    API.get(
      `direction-plan-beta/get-course-blocks/${getParams(conf)}`,
      getHeaders(),
    ),
  getLessonData: (conf) =>
    API.get(`direction-plan-beta/view-lesson/${getParams(conf)}`, getHeaders()),

  getScheduleBeta: (conf) =>
    API.get(`direction-plan-beta/get-block-themes${getParams(conf)}`),

  addTopic: (data) =>
    API.post('direction-plan-beta/create-theme', data, getHeaders()),
  addProbe: (data) =>
    API.post('direction-plan-beta/create-probe', data, getHeaders()),
  addControl: (data) =>
    API.post('direction-plan-beta/create-control', data, getHeaders()),
  addColloquium: (data) =>
    API.post('direction-plan-beta/create-colloquium', data, getHeaders()),
  getBlockThemes: (conf) =>
    API.get(
      `direction-plan-beta/get-block-themes/${getParams(conf)}`,
      getHeaders(),
    ),
  changeThemesSorting: (conf) =>
    API.post(`direction-plan-beta/change-themes-sorting/`, conf.data),
  sorting: (conf) =>
    API.post(`direction-plan-beta/change-lesson-sorting`, conf.data),

  getCertificatePercentages: (params) =>
    API.get(`direction-plan-beta/certificate-percentages/${getParams(params)}`),
}

export const homeWorkApi = {
  get: (conf) => API.get(`home-work${getParams(conf)}`),
  view: (conf) => API.get(`home-work/view/${conf.id}${getParams(conf)}`),
  sendAnswer: (conf) =>
    API.post(
      `home-work/send-answer/${conf.id}${getParams(conf)}`,
      conf.data,
      getHeaders(['FormData']),
    ),
  add: (conf) => API.post(`home-work/set-home-work`, conf.data),
  addMass: (conf) => API.post(`home-work/set-home-work-mass`, conf.data),
  addLink: (conf) => API.post(`home-work/type-link`, conf.data),
  pass: (conf) => API.post(`home-work/pass-work?id=${conf.id}`, conf.data),
  evaluation: (conf) =>
    API.post(`home-work/work-evaluation?id=${conf.id}`, conf.data),
  getOwnWorks: (conf) => {
    if (cancelToken.getWorks)
      cancelToken.getWorks.cancel(
        'Previous request canceled due to new request.',
      )
    cancelToken.getWorks = axios.CancelToken.source()

    return API({
      url: `home-work/get-own-works/${getParams(conf)}`,
      cancelToken: cancelToken.getWorks.token,
      method: 'GET',
    })
  },
  getOwnWorksForRedax: (conf) => {
    return API({
      url: `home-work/get-own-works/${getParams(conf)}`,
      method: 'GET',
    })
  },

  getAllWorks: (conf) => API.get(`home-work/get-all-works/${getParams(conf)}`),
  addCommentFile: (conf) =>
    API.post(
      `home-work/add-comment-files`,
      conf.data,
      getHeaders(['FormData']),
    ),
  removeCommentFile: (conf) =>
    API.delete(
      `home-work/delete-comment-file?work_id=${conf.work_id}&task_id=${conf.task_id}&file_index=${conf.index}`,
    ),
  timeout: (conf) =>
    API.post(`home-work/work-evaluation?id=${conf.id}&timeout=true`, conf.data),
  setUnique: (conf) => API.post(`home-work/set-unique-home-work`, conf.data),
  setUniqueMass: (conf) =>
    API.post(`home-work/set-unique-home-work-mass`, conf.data),
  remove: (conf) => API.delete(`home-work/canceled-work?id=${conf.id}`),
  archive: (id, type) => API.post(`home-work/archive?id=${id}&type=${type}`),
  unarchive: (id, type) =>
    API.post(`home-work/unarchive?id=${id}&type=${type}`),
  edit: (conf) => API.post(`home-work/edit?id=${conf.id}`, conf.data),
  startTimer: (data) => API.post(`home-work/start-timer`, data),
  getTimer: (task_id, work_id) =>
    API.get(`home-work/get-timer?task_id=${task_id}&work_id=${work_id}`),
}

export const probeApi = {
  get: (conf) =>
    API.get(
      conf.id
        ? `probe/${getParams(conf)}&planId=${conf.id}`
        : `probe/${getParams(conf)}`,
    ),
  view: (conf) => API.get(`probe/view${getParams(conf)}&id=${conf.id}`),
  start: (conf) => API.post(`probe/start-probe?workId=${conf.id}`),
  pass: (conf) =>
    API.post(
      `probe/pass-work?workId=${conf.id}`,
      conf.data,
      getHeaders(['FormData']),
    ),

  getOwnWorks: (conf) => {
    if (cancelToken.getWorks)
      cancelToken.getWorks.cancel(
        'Previous request canceled due to new request.',
      )
    cancelToken.getWorks = axios.CancelToken.source()

    return API({
      url: `probe/get-own-works/${getParams(conf)}`,
      cancelToken: cancelToken.getWorks.token,
      method: 'GET',
    })
  },
  // getOwnWorks: (conf) => API.get(`probe/get-own-works${getParams(conf)}`),
  evaluation: (conf) =>
    API.post(`probe/work-evaluation?id=${conf.id}`, conf.data),
  getMy: (conf) => API.get(`probe/get-my-probes${getParams(conf)}`),
  addCommentFile: (conf) =>
    API.post(`probe/add-comment-files`, conf.data, getHeaders(['FormData'])),
  removeCommentFile: (conf) =>
    API.delete(
      `probe/delete-comment-file?work_id=${conf.work_id}&task_id=${conf.task_id}&file_index=${conf.index}`,
    ),
  timeout: (conf) =>
    API.post(`probe/work-evaluation?id=${conf.id}&timeout=true`, conf.data),
  remove: (conf) => API.delete(`probe/delete?id=${conf.id}`),
  edit: (conf) => API.post(`probe/edit?id=${conf.id}`, conf.data),
}

export const controlApi = {
  // get: (conf) => API.get(`control-work${getParams(conf)}`),
  get: (conf) => {
    if (cancelToken.getWorks)
      cancelToken.getWorks.cancel(
        'Previous request canceled due to new request.',
      )
    cancelToken.getWorks = axios.CancelToken.source()

    return API({
      url: `control-work/${getParams(conf)}`,
      cancelToken: cancelToken.getWorks.token,
      method: 'GET',
    })
  },
  view: (conf) => API.get(`control-work/view${getParams(conf)}&id=${conf.id}`),
  start: (conf) => API.post(`/control-work/start-work?id=${conf.id}`),
  pause: (conf) => API.post(`control-work/stop-work?id=${conf.id}`),
  sendAnswer: (conf) =>
    API.post(
      `control-work/send-answer?id=${conf.id}`,
      conf.data,
      getHeaders(['FormData']),
    ),
  pass: (conf) => API.post(`control-work/pass-work?id=${conf.id}`),
  evaluation: (conf) =>
    API.post(`control-work/work-evaluation?id=${conf.id}`, conf.data),

  addCommentFile: (conf) =>
    API.post(
      `control-work/add-comment-files`,
      conf.data,
      getHeaders(['FormData']),
    ),
  removeCommentFile: (conf) =>
    API.delete(
      `control-work/delete-comment-file?work_id=${conf.work_id}&task_id=${conf.task_id}&file_index=${conf.index}`,
    ),

  timeout: (conf) =>
    API.post(
      `control-work/work-evaluation?id=${conf.id}&timeout=true`,
      conf.data,
    ),
  remove: (conf) => API.delete(`control-work/delete?id=${conf.id}`),

  edit: (conf) => API.post(`control-work/edit?id=${conf.id}`, conf.data),
}

export const recordingLessonAPI = {
  getAll: (conf) => API.get(`lesson-record${getParams(conf)}`),
  add: (conf) => API.post(`lesson-record/create`, conf.data),
  upd: (conf) =>
    API.put(`lesson-record/update/${conf.id}${getParams(conf)}`, conf.data),
  view: (conf) => API.get(`lesson-record/view/${conf.id}${getParams(conf)}`),
  remove: (conf) => API.delete(`lesson-record/delete?id=${conf.id}`),
}

export const timetableAPI = {
  getFamiliarLessonIds: (_) => API.get(`timetable/get-familiar-lesson-ids`),
  get: ({ params }) => API({ url: `timetable`, params, method: 'GET' }),
  getChildrenAll: ({ params }) =>
    API({ url: `timetable/children-all`, params, method: 'GET' }),
  getChildren: ({ params }) =>
    API({ url: `timetable/children-own`, params, method: 'GET' }),
  show: (id, date = null) => API.get(`timetable/show?id=${id}&date=${date}`),
  add: (conf) =>
    API.post(`timetable/create?conference=${conf.type}`, conf.data),
  done: (conf) => API.post(`timetable/done?id=${conf.id}`, conf.data),
  changeDiscount: (conf) =>
    API.post(
      `timetable/change-discount?id=${conf.id}&date=${conf.date}`,
      conf.data,
    ),
  reschedule: (conf) =>
    API.post(`timetable/reschedule?id=${conf.id}`, conf.data),
  changeSpeaker: (conf) =>
    API.post(`timetable/change-speaker?id=${conf.id}`, conf.data),
  conference: (body) =>
    API({ url: `timetable/conference-without-status`, ...body, method: 'GET' }),
  cancel: (conf) => API.post(`timetable/cancel?id=${conf.id}`, conf.data),

  cancelReport: (body) =>
    API({ url: `timetable/cancel-report`, ...body, method: 'POST' }),

  massReport: (data) =>
    API({ url: `timetable/mass-report`, data, method: 'POST' }),

  pupilsClass: (conf) =>
    API.post(`timetable/pupils-class?id=${conf.id}`, conf.data),

  seminariansСlasses: (conf) =>
    API.post(`timetable/seminarians-classes?id=${conf.id}`, conf.data),

  selectTopic: (conf) =>
    API.post(`timetable/select-topic?id=${conf.id}`, conf.data),

  recordingViaSchedule: (data) =>
    API.post(`timetable/enroll-via-schedule`, data),

  cancelRecording: (data) => API.post(`timetable/cancel-enrollment`, data),

  updateStatusComment: (data) =>
    API.post(`timetable-report/update-status-comment`, data),

  updateDuration: (data) => API.post(`timetable-report/update-duration`, data),

  saveTimeOpeningLessonFirstTime: (data) =>
    API.post(`timetable-report/record-entry-time`, data),
}

export const lessonAbstractAPI = {
  get: (conf) => API.get(`lesson-abstract${getParams(conf)}`),
  add: (conf) =>
    API.post(`lesson-abstract/create`, conf.data, getHeaders(['FormData'])),
  evaluation: (conf) =>
    API.post(`lesson-abstract/evaluation?id=${conf.id}`, conf.data),
  existAbstract: (conf) =>
    API.get(`lesson-abstract/exist-abstract?plan_id=${conf.id}`),
}

export const journalApi = {
  getHomeWork: ({ params }) =>
    API({ url: `student-journal/home-works`, params, method: 'GET' }),

  getProbe: ({ params }) =>
    API({ url: `student-journal/probe-works`, params, method: 'GET' }),

  getControlWork: ({ params }) =>
    API({ url: `student-journal/control-works`, params, method: 'GET' }),

  getAttendance: ({ params }) =>
    API({ url: `student-journal/attendance`, params, method: 'GET' }),
  addAttendance: (conf) =>
    API.post(`student-journal/add-attendance`, conf.data),
  editGrades: (conf) => API.put('student-journal/edit-grades', conf.data),
  periodCreate: (data) => API.post(`/journal-periods/create-period`, data),
  periodUpdate: (id, data) => API.put(`/journal-periods/update/${id}`, data),
  periodGet: () => API.get(`/journal-periods/list`),
  periodDelete: (id) => API.delete(`/journal-periods/delete/${id}`),
  updateButtons: (data) => API.put('student-journal/update-buttons', data),
  getButtons: () => API.put('student-journal/buttons'),
  periodGrage: (id) =>
    API.delete(`/student-journal/delete-grade?gradeId=${id}`),

  getColumnsSettings: () => API.get(`student-journal/get-columns`),
  addColumnsSettings: (data) => API.post(`student-journal/add-columns`, data),
  fillAdditional: (data) => API.post(`student-journal/fill-additional`, data),
  getAdditional: ({ params }) =>
    API({ url: `/student-journal/show-additional`, params, method: 'GET' }),

  getWithReplacement: (id) =>
    API.get(`direction-group/with-replacement?id=${id}`),

  getKPT: (params) =>
    API({ url: `ktp-journal/${getParams(params)}`, method: 'GET' }),
  getCourseKPTBlocks: ({ params }) =>
    API({ url: `ktp-journal/course-blocks`, params, method: 'GET' }),
  updateKTP: (data) => API.put('ktp-journal/update', data),
  updateKTPLessonsAccess: (groupId) =>
    API.get(`ktp-journal/update-access?group_id=${groupId}`),
  removeKTP: (id, disabled) =>
    API.delete(`ktp-journal/delete?id=${id}&disabled=${disabled}`),
  downloadKPT: (id, params) =>
    API.get(`ktp-journal/export?group=${id}`, params),
  downloadKPTdraft: (params) =>
    API.get(`ktp-journal/download-template`, params),
  uploadKTP: (body, config) =>
    API.post(`ktp-journal/upload`, body, {
      ...config,
      headers: getHeaders(['FormData']),
    }),
}

export const seminarPresentationAPI = {
  get: (conf) => API.get(`seminar-presentation${getParams(conf)}`),
  getType: (body) => API.get(`seminar-presentation/get-seminar-types`),
  add: (conf) => API.post(`seminar-presentation/create`, conf.data),
  upd: (conf) =>
    API.put(`seminar-presentation/update?id=${conf.id}`, conf.data),
  remove: (conf) => API.delete(`seminar-presentation/delete?id=${conf.id}`),
}

export const reportAPI = {
  getDisabledOrders: (conf) =>
    API.get(`reports/disabled-orders${getParams(conf)}`, getHeaders()),
  getSales: (conf) => API.get(`reports/sales${getParams(conf)}`, getHeaders()),

  reportForParents: {
    get: (body) =>
      API({ url: `reports/report-for-parents`, ...body, method: 'GET' }),
    add: (body) =>
      API({ url: `reports/create-report-parent`, ...body, method: 'POST' }),
    transferred: (conf) =>
      API.post(`reports/transferred-report-parent?id=${conf.id}`),
    getChildren: ({ params }) =>
      API({ url: `reports/child-for-parent-report`, params, method: 'GET' }),
  },

  private: {
    week: ({ params }) =>
      API({ url: `reports/private-week`, params, method: 'GET' }),
    seminarian: ({ params }) =>
      API({ url: `reports/private-seminarian`, params, method: 'GET' }),
    seminarianToExcel: ({ params }) =>
      API({
        url: `reports/private-seminarian-to-excel`,
        params,
        method: 'GET',
      }),
    students: ({ params }) =>
      API({ url: `reports/private-students`, params, method: 'GET' }),
  },

  lectureAnalytics: ({ params }) =>
    API({ url: `reports/lecture-analytics`, params, method: 'GET' }),

  group: {
    group: (body) => API({ url: `reports/groups`, ...body, method: 'GET' }),
    wrapper: ({ params }) =>
      API({ url: 'reports/group-reports', params, method: 'GET' }),
    overview: ({ params }) => {
      if (cancelToken.groupOverview)
        cancelToken.groupOverview.cancel(
          'Previous request canceled due to new request.',
        )
      cancelToken.groupOverview = axios.CancelToken.source()

      return API({
        url: `reports/groups-overview`,
        params,
        cancelToken: cancelToken.groupOverview.token,
        method: 'GET',
      })
    },

    seminarian: ({ params }) => {
      if (cancelToken.groupSeminarian)
        cancelToken.groupSeminarian.cancel(
          'Previous request canceled due to new request.',
        )
      cancelToken.groupSeminarian = axios.CancelToken.source()

      return API({
        url: `reports/group-seminarian`,
        params,
        cancelToken: cancelToken.groupSeminarian.token,
        method: 'GET',
      })
    },
  },

  payments: {
    payments: (body) => API({ url: `reports/payments`, ...body }),
    paymentsv2: ({ params, ...conf }) => API.get(`reports/paymentsv2/${getParams(conf)}`, getHeaders()),
    paymentsRemove: (id) => API.get(`polymorph-payment/remove/${id}`),
  },
  
  ownBacklog: (body) => API({ url: 'reports/own-backlog', ...body }),

  sop: {
    get: (body) => API({ url: 'reports/sop-questions', ...body }),
    send: (body) => API({ url: 'reports/sop-send', ...body, method: 'POST' }),
  },

  platformVisits: (params) =>
    API({ url: `reports/platform-visits`, params, method: 'GET' }),

  platformVisitsUpdate: () =>
    API({ url: '/reports/platform-visits-refresh', method: 'POST' }),

  getDebtorPaymentReport: (params) =>
    API({ url: `reports/list-debtors/${getParams(params)}`, method: 'GET' }),
  updateDebtorPaymentComment: (body) =>
    API.post('reports/debtor-update-comment', body),
  updateExtendDebtor: (body) => API.post('reports/extend-debtor', body),
}

export const promoCodeAPI = {
  get: (body) => API({ url: `promo-code`, ...body }),
  add: (conf) => API.post(`promo-code/create`, conf.data),
  remove: (conf) => API.delete(`promo-code/delete?id=${conf.id}`),
  check: (name) => API.get(`promo-code/check?name=${name}`),
}

export const supportAPI = {
  get: (body) => API({ url: `support/index`, ...body }),
  getTypes: (body) => API({ url: `support/get-support-types`, ...body }),
  add: (body) =>
    API({
      url: `support/create`,
      ...body,
      method: 'POST',
      headers: { 'Content-type': 'multipart/form-data' },
    }),
  done: (body) => API({ url: `support/done`, ...body, method: 'POST' }),
  accepted: (body) => API({ url: `support/accepted`, ...body, method: 'POST' }),
  cancel: (body) => API({ url: `support/cancel`, ...body, method: 'POST' }),
  remove: (body) => API({ url: `support/delete`, ...body, method: 'DELETE' }),
  unreadCount: () => API.get('support/unread-count'),
  read: (supportId) => API.post('support/read', { supportId }),
  getManualPaymentsOrders: (body) => API.get(`support/get-manual-payments`, {...body}),
  changeStatusManualPayment: (id, status) => API.get(`support/set-manual-payment-status/${ id }`, { params: { status } }),
}

export const bannerApi = {
  index: (body) => API({ url: `banner/index`, ...body, method: 'GET' }),
  show: (id) => API.get(`banner/show?id=${id}`),
  create: (data) =>
    API.post(`banner/create`, data, {
      headers: { 'Content-type': 'multipart/form-data' },
    }),
  update: (data) =>
    API.post(`banner/update`, data, {
      headers: { 'Content-type': 'multipart/form-data' },
    }),
  remove: (id) => API.post(`banner/delete?id=${id}`),
  copy: (data) => API.post(`banner/copy`, data),
  sort: (data) => API.post(`banner/sort`, data),
}

export const excelAPI = {
  getExcelTable: (body) => API({ url: 'user/export', ...body, method: 'GET' }),
}

export const communicationApi = {
  index: (params) => API.get('communication', { params }),
  update: (id, params) => API.put(`communication/update/${id}`, params),
  count: () => API.get('communication/count'),
}

export const settingApi = {
  getAll: () => API.get('setting/get-all'),
  ensureReports: () => API.get('setting/ensure-reports'),
  update: (params) => API.put('setting/update-setting', params),
  uploadLogo: (data) => API.post('setting/upload-logo', data),
  uploadFavicon: (data) => API.post('setting/upload-favicon', data),
  uploadImageLoginPage: (data) => API.post('setting/update-auth-image', data),
  uploadCatalogLogo: (data) => API.post('setting/update-catalog-image', data),
  switchHundredSystem: (data) =>
    API.post('setting/switch-hundred-point-system', data),
  getNotificationSettings: () => API.get('setting/get-notification-settings'),
  saveNotificationContent: (data) =>
    API.post('setting/save-notification-content', data),
  getNotificationTypes: () => API.get('setting/get-notification-types'),
  updateNotificationTypeEnabled: (data) =>
    API.post('setting/update-notification-type', data),
  uploadCourseCatalogHeaderIcon: (data) =>
    API.post('setting/update-catalog-image', data),
}

export const notificationApi = {
  getNotifications: () => API.get(`notification/get-notifications`),
  markAsRead: () => API.put('notification/mark-as-read'),
}

export const notificationByTriggerApi = {
  getAllNotifications: () => API.get(`trigger-notification`),
  getNotification: (id) => API.get(`trigger-notification/view?id=${id}`),
  deleteNotification: (id) =>
    API.delete(`trigger-notification/delete?id=${id}`),
  updateNotificationOrder: (data) =>
    API.post(`trigger-notification/update-order`, data),
  createNotification: (data) =>
    API.post(`trigger-notification/create`, data),
  updateNotification: (id, data) =>
    API.put(`trigger-notification/update?id=${id}`, data),
}

export const menuApi = {
  getMenu: (language, menuType) =>
    API.get(`menu/get-active-menu?language=${language}&menuType=${menuType}`),
  getByRoleName: (roleName, language, menuType) =>
    API.get(
      `menu/get-menu?roleName=${roleName}&language=${language}&menuType=${menuType}`,
    ),
  changeActive: (id, roleName, menuType) =>
    API.put(
      `menu/change-active?id=${id}&roleName=${roleName}&menuType=${menuType}`,
    ),
  changeMenuItemName: (id, name, language, menuType, roleName) =>
    API.put(
      `menu/change-menu-item-name?id=${id}&name=${name}&language=${language}&menuType=${menuType}&roleName=${roleName}`,
    ),
  changeRank: (id, roleName, isUp, menuType) =>
    API.put(
      `menu/change-rank?id=${id}&roleName=${roleName}&isUp=${isUp}&menuType=${menuType}`,
    ),
  saveNewMenuItem: (data) => API.post('menu/create-menu-item', data),
  updateMenuItemUrl: (id, url) =>
    API.put(`menu/update-menu-url?id=${id}&url=${url}`),
  deleteMenuItem: (id) => API.delete(`menu/delete-menu-item/${id}`),
  createFolder: (data) => API.post('menu/create-folder', data),
  deleteFolder: (id) => API.delete(`menu/delete-folder/${id}`),
  renameFolder: (id, data) => API.put(`menu/rename-folder/${id}`, data),
  changeFolderRank: (id, roleName, isUp) =>
    API.put(
      `menu/change-folder-rank?id=${id}&roleName=${roleName}&isUp=${isUp}&menuType=basic`
    ),
  moveItem: (id) => API.put(`menu/move-item?itemId=${id}`),
  moveItemToFolder: (itemId, folderId) => API.put(
    `menu/move-item?itemId=${itemId}&folderId=${folderId}`
  ),
}

export const menuReportApi = {
  getMenu: (roleName) =>
    API.get(`menu-report/get-active-menu?roleName=${roleName}`),
  getByRoleName: (roleName, language) =>
    API.get(`menu-report/get-menu?roleName=${roleName}&language=${language}`),
  changeActive: (id, roleName) =>
    API.put(`menu-report/change-active?id=${id}&roleName=${roleName}`),
  changeMenuItemName: (id, name, language) =>
    API.put(
      `menu-report/change-menu-item-name?id=${id}&name=${name}&language=${language}`,
    ),
  changeRank: (id, roleName, isUp) =>
    API.put(
      `menu-report/change-rank?id=${id}&roleName=${roleName}&isUp=${isUp}`,
    ),
}

export const publicUrl = [
  'setting/get-all',
  'survey/create-report',
  'survey/take-survey',
  'survey/get-pass',
  'survey/get-finish-window',
  'direction-filter',
  'direction-filter/get-subfolders',
  'banner/index',
  'direction',
  'direction/view',
  'promo-code',
  'user/check-email',
  'direction-orders/enroll-direction',
  'auth/restore-password',
  'user/signup',
  'common/return-image',
  'crm-lead-payment-link/get-link',
  'classes/show',
  'classes/enroll-class'
]

export const faqApi = {
  get: (params) => API.get(`faq/get`, { params }),
  create: (params) => API.post('faq/create', params),
  update: (id, params) => API.put(`faq/update/${id}`, params),
  delete: (id) => API.delete(`faq/delete/${id}`),
}

export const adminPasswordsApi = {
  get: (params) => API.get('admin-passwords/get-password-by-key', { params }),
}
export const reactionsToTheVideo = {
  get: (params) => API.get('/topic-lesson/own-lesson-video-rating', { params }),
}

export const seminarianUncheckedHomework = {
  get: (params) =>
    API.get('/reports/seminarian-unchecked-homework-count', { params }),
}

export const fcmApi = {
  storeToken: (token) => API.post('fcm-messaging/store-token', { token }),
  removeToken: (token) => API.post('fcm-messaging/remove-token', { token }),
}

export const chatApi = {
  getUsersChatsList: (params) =>
    API.get(`chat/get-users-chat-name-list?search=`, { params }),
  // getUserList: (params) => API.get(`get-users-chat-name-list`, {params}),
  createChat: (params) => API.post(`chat/create-chat`, params),
  getChatList: (params) => API.get(`chat/chat-list`, { params }),
  getChat: (id) => API.get(`chat/chat-messages/${id}`),
  getActiveUsers: () => API.get(`chat/get-active-users`),
  createMessage: (params, config) =>
    API.post(`chat/create-message`, params, config),
  addMember: (params) => API.post(`chat/add-member`, params),
  deleteMember: (id) => API.delete(`chat/remove-member/${id}`),
  readAllChatMessages: (chatId) => API.put(`chat/read-messages/${chatId}`),
  fixMessage: (id) => API.put(`chat/fix-message/${id}`),
  updateChatTitle: (id, params) => API.put(`chat/update-chat/${id}`, params),
  updateChatImage: (id, params, config = {}) =>
    API.post(`chat/update-chat-avatar/${id}`, params, {
      ...config,
      headers: getHeaders().headers,
    }),
  removeChat: (id) => API.delete(`chat/remove-chat/${id}`),
  removeMessage: (id) => API.delete(`chat/remove-message/${id}`),
  fixChat: (id) => API.put(`chat/fix-chat/${id}`),
  updateRoleMember: (id, params) => API.put(`chat/update-member/${id}`, params),
  addMessageFile: (id, params, config) =>
    API.post(`chat/add-message-file/${id}`, params, config),
  unFixMessage: (chatId) => API.put(`chat/unfix-message/${chatId}`),
  unFixChat: () => API.put(`chat/unfix-chat`),
  mute: (id) => API.post(`chat/mute?id=${id}`),
  unmute: (id) => API.post(`chat/unmute?id=${id}`),
}

export const classApi = {
  index: () => API.get('classes'),
  getClassesById: (folderId) => API.get(`classes?folder_id=${folderId}`),
  getClassesByDirection: (directionId) =>
    API.get(`classes?direction_id=${directionId}`),
  getClassesAndFolders: (params) =>
    API.get(`classes/get-classes-info/${getParams(params)}`),
  show: (id) => API.get(`classes/show/${id}`),
  showByUser: (userId) => API.get(`classes/show-by-user?userId=${userId}`),
  showForPayment: (conf) => API.get(`classes/show-for-payment${getParams(conf)}`),
  create: (params) => API.post(`classes/create`, params),
  update: (id, params) => API.post(`classes/update/${id}`, params),
  delete: (id) => API.delete(`classes/delete/${id}`),
  attachChildren: (id, params) =>
    API.post(`classes/attach-children/${id}`, params),
  detachChildren: (id, params) =>
    API.post(`classes/detach-children/${id}`, params),
  attachUserClassGroup: (id, params) =>
    API.post(`classes/attach-user-class-group/${id}`, params),
  detachUserClassGroup: (id, params) =>
    API.post(`classes/detach-user-class-group/${id}`, params),
  changePriceForChild: (params) =>
    API.post('classes/change-price-for-child', params),
  changeDiscountForChild: (params) =>
    API.post('classes/change-discount-for-child', params),
  createCopy: (data) => API.post('/classes/create-copy', data),
  massPaymentAmountUpdate: (data) =>
    API.post('/classes/mass-payment-amount-update', data),

  folders: () => API.get('/class-folder'),
  addFolder: (params) => API.post('/class-folder/add-new', params),
  editFolder: (idFolder, params) =>
    API.put(`/class-folder/rename/${idFolder}`, params),
  deleteFolder: (id) => API.delete(`/class-folder/delete/${id}`),
  sorting: (conf) => API.post(`/classes-sorting`, conf.data),
  enroll: (data) => API.post(`classes/enroll-class`, data),
}

export const languagesApi = {
  save: (params) => API.post(`languages/save-settings`, params),
}

export const news = {
  get: (id) => API.get(`news/view/${id}`),
  getAll: () => API.get(`news`),
  create: () => API.post(`news/draft-or-new`),
  delete: (id) => API.post(`news/delete/${id}`),
  save: (id, param) => API.post(`news/save/${id}`, param),
  createBlock: (newsId) => API.post(`news/new-block`, newsId),
  updateBlock: (id, param) => API.post(`news/update-block/${id}`, param),
  deleteBlock: (id) => API.delete(`news/delete-block/${id}`),
  createComment: (id, param) => API.post(`news/create-comment/${id}`, param),
  getComment: (id, first, last) =>
    API.get(`news/comments/${id}?first=${first}&last=${last}`),
  toggleLike: (id) => API.post(`news/toggle-like/${id}`),
  deleteСomment: (id) => API.post(`news/delete-comment/${id}`),
  changeRank: (params) => API.post(`news/change-rank`, params),
}

export const departments = {
  getAll: () => API.get(`/org-units`),
  getAllIndex: () => API.get(`/org-units/select-index`),

  departmentUpdate: (id, params) =>
    API({
      url: `org-units/update/${id}`,
      params,
      method: 'PUT',
    }),

  departmentUpdateAll: (params) => API.post(`/org-units/update-order`, params),

  create: (params) => API.post(`/org-units/create`, params),
  update: (id, params) => API.post(`org-units/update/${id}`, params),
  delete: (id) => API.delete(`org-units/delete/${id}`),
  addAnEmployeeToDepartment: (params) =>
    API.post(`/org-units/add-user`, params),

  utUsers: (id) => API.get(`org-units/users-list/${id}`),
  deleteEmployee: (params) =>
    API({ url: `org-units/remove-user/`, params, method: 'DELETE' }),

  userScriptorAdeptoDepartments: (id) =>
    API.get(`org-units/list-by-user/${id}`),
}

export const teams = {
  getAll: () => API.get(`/teams`),
  getAllIndex: () => API.get(`/teams/select-index`),

  teamUpdate: (id, params) =>
    API({
      url: `teams/update/${id}`,
      params,
      method: 'PUT',
    }),

  teamUpdateAll: (params) => API.post(`/teams/update-order`, params),

  create: (params) => API.post(`/teams/create`, params),
  update: (id, params) => API.post(`teams/update/${id}`, params),
  delete: (id) => API.delete(`teams/delete/${id}`),
  addAnEmployeeToTeam: (params) => API.post(`/teams/add-user`, params),

  utUsers: (id) => API.get(`teams/users-list/${id}`),
  deleteEmployee: (params) =>
    API({ url: `teams/remove-user/`, params, method: 'DELETE' }),

  userScriptorAdeptoDepartments: (id) => API.get(`teams/list-by-user/${id}`),
}

export const library = {
  createSection: (params) => API.post(`confluence/new-header`, params),
  editSection: (id, data) =>
    API({
      url: `confluence/save-header/${id}`,
      data,
      method: 'PUT',
    }),
  editPage: (id, data) =>
    API({
      url: `/confluence/save-page/${id}`,
      data,
      method: 'PUT',
    }),
  editBlock: (id, data) => API.post(`/confluence/update-block/${id}`, data),
  createBlock: (params) => API.post(`/confluence/new-block`, params),
  detAll: () => API.get(`confluence`),
  createPage: (params) => API.post(`confluence/draft-or-new`, params),
  getPage: (id) => API.get(`/confluence/view-page/${id}`),
  deleteBlock: (id) => API.delete(`/confluence/delete-block/${id}`),
  deleteSection: (id) => API.delete(`/confluence/delete-header/${id}`),
  deletePage: (id) => API.delete(`/confluence/delete-page/${id}`),
  changeRank: (data) =>
    API({
      url: `/confluence/change-rank`,
      data,
      method: 'PUT',
    }),
  changeRankSections: (data) =>
    API({
      url: `/confluence/change-rank-header`,
      data,
      method: 'PUT',
    }),
  changeRankPage: (data) =>
    API({
      url: `/confluence/change-rank-page`,
      data,
      method: 'PUT',
    }),
  createDepartmentInPage: (params) =>
    API.post(`/confluence/add-org-unit`, params),
  getPageUnits: (id) => API.get(`/confluence/page-units?pageId=${id}`),
  deleteDepartmentInPage: (params) =>
    API.post(`/confluence/remove-org-unit`, params),
}
export const lessonСompleted = {
  completed: (id, params) =>
    API.post(`topic-lesson/lesson-completed/${id}`, params),
}

export const rolesOrder = {
  getList: () => API.get(`auth/list-roles-order`),
  listUpdate: (params) => API.post(`auth/update-roles-order`, params),
  nameUpdate: (params) => API.put(`auth/update-role-name`, params),
}

export const schoolAndUniversitySettings = {
  getAll: () => API.get(`direction/school-and-university`),
  update: (params) =>
    API.post(`direction/update-school-and-university`, params),
}

export const workingHours = {
  delete: (id) => API.delete(`work-hours/delete?id=${id}`),
  create: (params) => API.post(`work-hours/create`, params),
}

export const replenishmentSingleBalance = {
  replenish: (params) => API.post(`polymorph-payment/balance-deposit`, params),
  view: (conf) => API.get(`polymorph-payment/check-payment?id=${conf.id}`),
  updateLink: (conf) => API.get(`polymorph-payment/update-link?id=${conf.id}`),
}

export const paymentUpdate = {
  update: () => API.post(`polymorph-payment/check-payment`),
}

export const surveyApi = {
  getAll: ({ params, ...conf }) =>
    API.get(`survey/get-all${getParams(conf)}`, getHeaders()),
  analyticsUsers: ({ params, ...conf }) =>
    API.get(`survey/analytics-users${getParams(conf)}`, getHeaders()),

  analytics: ({ params, id, ...conf }) =>
    API.get(
      `survey/get-survey-analytics${getParams(conf)}&id=${id}`,
      getHeaders(),
    ),

  answers: ({ params, surveyId, ...conf }) =>
    API.get(
      `survey/get-survey-results${getParams(conf)}&survey_id=${surveyId}`,
      getHeaders(),
    ),
  answersResend: ({ params, surveyId, ...conf }) =>
    API.get(
      `survey/get-survey-results-resend${getParams(
        conf,
      )}&survey_id=${surveyId}`,
      getHeaders(),
    ),

  responseRate: ({ id }) => API.get(`response-rate?id=${id}`, getHeaders()),

  responseRateLoadMoreAnswers: ({ id, answerId, start, quantity }) =>
    API.get(
      `survey/response-rate-load-more-answers?id=${id}&answer_id=${answerId}&start=${start}&quantity=${quantity}`,
      getHeaders(),
    ),

  getUsersWithSentEmails: (id) =>
    API.get(`survey/get-users-with-sent-emails?id=${id}`, getHeaders()),

  getSettings: (id) => API.get(`survey/get-settings?id=${id}`, getHeaders()),

  getAllQuestions: (id) =>
    API.get(`survey/get-all-questions?id=${id}`, getHeaders()),

  view: (id) => API.get(`survey/get-view?survey_report_id=${id}`, getHeaders()),
  pass: (id) => API.get(`survey/get-pass?survey_report_id=${id}`, getHeaders()),
  passFollowingLink: (id) => API.get(`survey/get-pass?id=${id}`, getHeaders()),

  deleteSurvey: (id) => API.delete(`survey/delete?id=${id}`),
  deleteQuestion: (id) => API.delete(`survey/delete-question?id=${id}`),
  deleteWindow: (id) => API.delete(`/survey/delete-finish-window?id=${id}`),

  askSurvey: (id) => API.post(`survey/resend?survey_id=${id}`),

  updateSettings: (params) => API.post(`survey/update-settings`, params),
  updateTask: (params) => API.post(`survey/update-task`, params),

  updateFinishWindow: (id, params) =>
    API.post(`survey/update-finish-window?id=${id}`, params),

  getAccess: (id) => API.get(`survey/get-availables?survey_id=${id}`),
  saveAccess: (params) => API.post(`survey/save-available`, params),
  createFinishWindow: (id) =>
    API.post(`survey/create-finish-window?survey_id=${id}`),
  getFinishWindows: (id) =>
    API.post(`survey/get-finish-windows?survey_id=${id}`),
  getFinishWindow: (id) => API.get(`/survey/get-finish-window?finish_id=${id}`),
  getUsers: (id) => API.get(`survey/get-extra-users?survey_id=${id}`),
  saveUser: (params) => API.post(`survey/save-extra-user`, params),

  takeSurvey: (params) => API.post(`survey/take-survey`, params),
  createReport: (query, params) =>
    API.post(`survey/create-report${query}`, params),
  create: (params) => API.post(`survey/create`, params),
  saveOrder: (params) => API.post(`survey/save-order`, params),
  saveOrderQuestions: (params) =>
    API.post(`survey/save-order-questions`, params),
  createTask: (params) => API.post(`survey/create-task`, params),
  answerOptions: (params) => API.post(`survey/answer-options`, params),

  getMysurvey: ({ params, ...conf }) =>
    API.get(`survey/get-my-survey${getParams(conf)}`, getHeaders()),

  getAttachedCourses: ({ params, ...conf }) =>
    API.get(`survey/get-attached-courses${getParams(conf)}`, getHeaders()),

  createCopy: (params) => API.post(`survey/create-copy`, params),
}

export const images = {
  getAccessCanvas: (params) => API.post(`common/return-image`, params),
}

export const mailingsApi = {
  save: (params) => API.post(`mailing/save-mailing`, params),
  get: (id) => API.get(`mailing/get-mailing-schedule?mailing_id=${id}`),
  getAll: (conf) =>
    API.get(`mailing/get-all-mailing/${getParams(conf)}`, getHeaders()),

  saveDateTime: (params) => API.post(`mailing/save-date-time`, params),
  saveBlocks: (params) => API.post(`mailing/save-blocks`, params),
  saveBlock: (params) => API.post(`mailing/save-block`, params),
  getBlocks: (id) => API.get(`mailing/get-blocks?mailing_id=${id}`),
  deleteBlock: (id) => API.get(`mailing/delete-block?id=${id}`),
  deleteMailing: (params) => API.post(`mailing/delete-mailing`, params),
  getAccess: (id) => API.get(`mailing/get-availables?mailing_id=${id}`),
  getUsers: (id) => API.get(`mailing/get-extra-users?mailing_id=${id}`),
  saveUser: (params) => API.post(`mailing/save-extra-user`, params),
  saveAccess: (params) => API.post(`mailing/save-available`, params),
  sendTest: (params) => API.post(`mailing/send-test-mail`, params),
  resend: (id) => API.post(`mailing/resend?mailing_id=${id}`),
}

export const massActionsApi = {
  make: (data) => API.post(`mass-actions/make`, data),
  changeStatus: (data) => API.post(`user/mass-change-status`, data),
  sendInvite: (data) => API.post(`user/mass-send-invite`, data),
  addCourses: (data) => API.post(`direction-orders/mass-enroll`, data),
  addClassesDirections: (data) => API.post(`classes/mass-enroll`, data),
  addDepartment: (data) => API.post(`user/mass-add-department`, data),
  removeDepartment: (data) => API.post(`user/mass-remove-department`, data),
  removeCourses: (data) => API.post(`direction-orders/mass-unenroll`, data),
  removeClasses: (data) => API.post(`classes/mass-unenroll`, data),
}

export const paymentIntegrationApi = {
  getConfigs: () => API.get(`integration-configs`, getHeaders()),
  getConfig: (id) => API.get(`integration-configs/${id}`),
  putConfig: (id, data) => API.put(`integration-configs/update/${id}`, data),
  deleteConfig: (id) => API.delete(`integration-configs/${id}`),
}

export const smsIntegrationApi = {
  getSms: () => API.get(`/integration-configs/get-sms`, getHeaders()),
  connectSms: (data) => API.post(`/integration-configs/connect-sms`, data),
  getToken: (data) => API.post(`/auth/send-code`, data),
  getTokenRequiredNumberСonfirmation: (data) => API.post(`/auth/send-conf-code`, data),
  confirmationCode: (data) => API.post(`/auth/conf-code`, data),
}